<div class="p-4 sm:p-6 bg-shui-base-1">
    <h1 class="font-bold text-lg sm:text-xl text-shui-text-active p-0 m-0">
        {{ 'common.scd-picker.title' | translate }}
    </h1>
    <p class="text-sm sm:text-md text-shui-text-subtle p-0 m-0 mt-1">
        {{ 'common.scd-picker.subtitle' | translate }}
    </p>

    <form [formGroup]="formGroup" class="grid grid-cols-1 sm:grid-cols-[1fr_1fr_1fr_40px] gap-2 mt-4 items-start">
        <sh-input-text
            [label]="'common.scd-picker.first-name' | translate"
            formControlName="firstName"
            [attr.error]="firstNameError() ? true : null"
            [attr.error-message]="firstNameError() ? (firstNameError() | translate) : null"
            (keydown.enter)="focusNext($any($event))"
        ></sh-input-text>

        <sh-input-text
            [label]="'common.scd-picker.last-name' | translate"
            formControlName="lastName"
            [attr.error]="lastNameError() ? true : null"
            [attr.error-message]="lastNameError() ? (lastNameError() | translate) : null"
            (keydown.enter)="focusNext($any($event))"
        ></sh-input-text>

        <sh-input-text
            [label]="'common.scd-picker.gid' | translate"
            formControlName="gid"
            (keydown.enter)="focusNext($any($event))"
        ></sh-input-text>

        <sh-button
            icon="search"
            layout="normal"
            size="s"
            class="rounded-md"
            [disabled]="loading()"
            (click)="onSearch()"
            (keydown.enter)="focusNext($any($event))"
        ></sh-button>
    </form>

    <div class="sr-only" aria-live="polite" aria-atomic="true" id="scd-announcement"></div>

    <div class="h-[200px] sm:h-[300px] my-4 overflow-y-auto">
        <div class="hidden sm:grid grid-cols-3 px-4 py-1 text-sm text-shui-text-moderate">
            <span class="truncate">{{ 'common.scd-picker.name' | translate }}</span>
            <span class="truncate">{{ 'common.scd-picker.gid' | translate }}</span>
            <span class="truncate">{{ 'common.scd-picker.department' | translate }}</span>
        </div>

        @if (loading()) {
            <div class="space-y-2 animate-pulse px-4">
                <div class="h-14 bg-white/10 rounded-md"></div>
                <div class="h-14 bg-white/10 rounded-md opacity-80"></div>
                <div class="h-14 bg-white/10 rounded-md opacity-60"></div>
            </div>
        } @else {
            @if (searchResults().length > 0) {
                @for (item of searchResults(); track item.gid) {
                    <div
                        class="cursor-pointer bg-white/10 hover:bg-white/20 rounded-md p-4 mb-2"
                        tabindex="0"
                        role="option"
                        (click)="onSelect(item)"
                        (keydown.space)="onSelect(item)"
                        (keydown.enter)="focusNext($any($event))"
                    >
                        <!-- Mobile layout -->
                        <div class="block sm:hidden w-full text-sm space-y-1">
                            <div class="font-medium text-shui-text-active">{{ item.firstName }} {{ item.surName }}</div>
                            <div class="text-gray-400 text-xs">
                                <span class="mr-4">GID: {{ item.gid }}</span>
                                <span>{{ item.department }}</span>
                            </div>
                        </div>
                        <!-- Desktop layout -->
                        <div class="hidden sm:grid grid-cols-3 w-full text-sm">
                            <span class="truncate text-shui-text-active">{{ item.firstName }} {{ item.surName }}</span>
                            <span class="truncate text-shui-text-active">{{ item.gid }}</span>
                            <span class="truncate text-shui-text-active">{{ item.department }}</span>
                        </div>
                    </div>
                }
            } @else {
                <div class="text-center text-shui-text-moderate flex items-center justify-center h-full">
                    {{ 'common.scd-picker.errors.no-results' | translate }}
                </div>
            }
        }
    </div>

    <div class="flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-2 mt-4">
        <sh-button
            [label]="'common.general.cancel' | translate"
            layout="normal"
            color="secondary"
            size="max-content"
            (click)="onClose()"
        ></sh-button>
    </div>
</div>
